import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMerged: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="merged"><circle cx="6" cy="6" r="2.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="6" cy="18" r="2.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="18" cy="18" r="2.25" stroke="currentColor" strokeWidth="1.5"/><path d="M6 8.25V15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/><path d="M8.5 6H18V15.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconMerged;
